
import React from 'react';
import AdminLoginPage from '@/components/admin/AdminLoginPage';

export default function AdminLogin() {
  return <AdminLoginPage />;
}
